export default function userReducer(draft, action) {
  switch (action.type) {
    case 'UPDATE_LOGGED_IN': {
      draft.loggedIn = !draft.loggedIn;
      break;
    }
    case 'UPDATE_EMAIL': {
      draft.email = action.email;
      break;
    }
    case 'UPDATE_NAME': {
      draft.name = action.name;
      break;
    }
    case 'UPDATE_SURNAME': {
      draft.surname = action.surname;
      break;
    }case 'UPDATE_SELECTED_PROFILE_ID': {
      draft.selectedProfile = {
        ...draft.selectedProfile,
        id: action.id,
      }
      break;
    }
    case 'UPDATE_SELECTED_PROFILE_NAME': {
      draft.selectedProfile = {
        ...draft.selectedProfile,
        name: action.name,
      }
      break;
    }
    case 'UPDATE_SELECTED_PROFILE_YEARCALC': {
      draft.selectedProfile = {
        ...draft.selectedProfile,
        yearCalc: action.yearCalc,
      }
      break;
    }
    case 'UPDATE_SELECTED_PROFILE': {
      draft.selectedProfile = action.profile;
      break;
    }
    case 'UPDATE_MFA_ENABLED': {
      draft.mfaEnabled = action.mfaEnabled;
      break;
    }
    case 'UPDATE_MFA_TYPE': {
      draft.mfaType = action.mfaType;
      break;
    }
    case 'RELOAD': {
      draft = action.settings;
      break;
    }
    default: {
      console.log("No action");
    }
  }
  return draft;
}